import { MsalAuthInfoBar } from "owa-app-msal-messagebar";
import { SkipLinkControl } from "owa-skip-link";
import { Module } from "owa-workloads-module";
import { Outlet, useLocation } from "react-router-dom";
import { PlacesAppHeaderWithRole } from "../HybridspaceAppHeader/PlacesAppHeaderWithRole";
import PlacesMessageBar from "../PlacesMessageBar/PlacesMessageBar";
import usePlacesMetaOS from "../PlacesMetaOS/usePlacesMetaOS";
import { appContainer } from "./PlacesRootRouteLayout.scss";
import type { JSX } from "react";

export function PlacesRootRouteLayout(): JSX.Element {
    usePlacesMetaOS();
    const location = useLocation();
    
    // Skip layout for place map view route
    const isPlaceMapView = location.pathname.startsWith("/place/");
    
    if (isPlaceMapView) {
        return <Outlet />;
    }
    
    return (<div className={appContainer}>
            <SkipLinkControl currentModule={Module.MicrosoftPlaces}/>
            <PlacesAppHeaderWithRole />
            <PlacesMessageBar />
            <MsalAuthInfoBar />
            <Outlet />
        </div>);
}
